export class GetBusinessDayRequest {
    NumberOfDays: number;
}

export default GetBusinessDayRequest;